import * as types from './actionTypes';  
import updateCustomerApi from '../api/updateCustomerApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doUpdateCustomer(request) {

  return {
    type: types.DO_UPDATE_CUSTOMER, 
    request
  };
}

export function doUpdateCustomerRes(data) {  
  return {
    type: types.DO_UPDATE_CUSTOMER_RES, 
    data
  };
}

export function sendUpdateCustomer(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      updateCustomerApi.doUpdateCustomer(request).then(data => {
        dispatch(doUpdateCustomerRes(data));
        dispatch(doUpdateCustomerRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}